const PUBLISH_AMOUNT_LOCALE = 'en-US';

const publishAmountFormatter = new Intl.NumberFormat(PUBLISH_AMOUNT_LOCALE, {
  maximumFractionDigits: 0,
});

export const formatBatchAmount = (value: number | null | undefined): string =>
  publishAmountFormatter.format(Math.round(value ?? 0));
